import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr(""); setMsg("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setMsg(data.message || "If an account exists, a reset link has been sent.");
        } catch (e2) {
            setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Something went wrong");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper p-8" data-testid="forgot-page">
            <form onSubmit={submit} className="w-full max-w-sm space-y-5 grid-card p-8">
                <div>
                    <div className="overline mb-2">Account recovery</div>
                    <h1 className="font-heading text-3xl font-extrabold tracking-tighter">Forgot password</h1>
                    <p className="text-sm text-muted2 mt-2">We'll email you a link to reset it.</p>
                </div>
                <div>
                    <label className="overline block mb-1.5">Email</label>
                    <input
                        data-testid="forgot-email"
                        type="email" required
                        value={email} onChange={(e) => setEmail(e.target.value)}
                        className="input-base"
                    />
                </div>
                {msg ? <div className="text-xs text-pos border border-pos/30 bg-pos/5 px-3 py-2 rounded-sm" data-testid="forgot-success">{msg}</div> : null}
                {err ? <div className="text-xs text-neg border border-neg/40 bg-neg/5 px-3 py-2 rounded-sm" data-testid="forgot-error">{err}</div> : null}
                <button type="submit" disabled={busy} data-testid="forgot-submit" className="btn-primary w-full">
                    {busy ? "Sending…" : "SEND RESET LINK"}
                </button>
                <div className="text-xs text-muted2 pt-3 border-t border-rule">
                    <Link to="/login" className="underline" data-testid="back-to-login">Back to sign in</Link>
                </div>
            </form>
        </div>
    );
}
